import { FC, useEffect } from "react";
import { useIsPageLoading } from "~/hooks/usePageIsLoading";

interface Props {
  children: React.ReactNode;
}

export const PageLoadingWrapper: FC<Props> = ({ children }) => {
  const { isPageLoading, setIsPageLoading } = useIsPageLoading();

  useEffect(() => {
    setIsPageLoading(false);
  }, [isPageLoading, setIsPageLoading]);

  return <>{children}</>;
};
